import { CARTS } from '@ab-core/hooks/cartNew/getCarts/getMyCartsQuery';
import type { MutationFunctionOptions } from '@apollo/client';
import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import type { UpdateShareStateResponseType } from '../cartNew/updateCart/updateCartShareState';
import { UPDATE_CART_SHARE_STATE } from '../cartNew/updateCart/updateCartShareState';

type DefaultMutationReturnType<T> = {
    success: boolean;
    error: boolean;
    errorMessage?: string;
    pending: boolean;
    response?: T;
    updateCartShareState: (options?: MutationFunctionOptions) => void;
};

export enum CartShareState {
    PUBLIC = 'public',
    PRIVATE = 'private'
}

type UpdateShareStateReturnType = DefaultMutationReturnType<UpdateShareStateResponseType>;

export const UpdateCartShareState = (): UpdateShareStateReturnType => {
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [response, setResponse] = useState<UpdateShareStateResponseType | undefined>(undefined);
    const [pending, setPending] = useState(false);
    const [updateCartShareState, { loading }] = useMutation<UpdateShareStateResponseType>(UPDATE_CART_SHARE_STATE, {
        update: () => {
            setSuccess(false);
            setErrorMessage('');
            setError(false);
        },
        onCompleted: (res) => {
            setResponse(res);
            setSuccess(true);
            setPending(false);
        },
        onError: (err) => {
            setErrorMessage(err.message);
            setError(true);
            setPending(false);
        },
        refetchQueries: [
            {
                query: CARTS
            }
        ]
    });
    useEffect(() => {
        if (loading === true) {
            setPending(true);
        }
    }, [loading]);

    return {
        updateCartShareState,
        success,
        error,
        response,
        errorMessage,
        pending
    };
};
